<div class="loading-filter">
    <img src="../../assets/loading-icon/loading-icon-webuyanycar-gif.gif" class="logo-animation" alt="Loading">
</div>